<!-- <svg width="5" height="13" viewBox="0 0 5 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4.5L2.5 0.5L5 4.5H0Z" fill="white" />
    <path d="M0 8.5L2.5 12.5L5 8.5H0Z" fill="white" />
</svg> -->

<div class="sort-arrows">
    <ng-container *ngIf="direction === 'asc'">
        <!-- Ascending arrow icon -->
        <mat-icon>arrow_drop_up</mat-icon>
    </ng-container>
    <ng-container *ngIf="direction === 'desc'">
        <!-- Descending arrow icon -->
        <mat-icon>arrow_drop_down</mat-icon>
    </ng-container>
    <ng-container *ngIf="!direction">
        <!-- Default icon (no sorting applied) -->
        <mat-icon>unfold_more</mat-icon>
    </ng-container>
</div>